// Microphone sensitivity presets for the OpenAI Realtime session.
// Chosen per tour in the admin avatar modal (avatar_json.micSensitivity).
//
//  high   — previous behaviour: loudness-based VAD, any detected sound
//           interrupts the avatar immediately. Quiet rooms / headsets.
//  normal — default: semantic VAD + far-field noise reduction; the avatar is
//           only cut off once the visitor has spoken for bargeInMs. Eagerness
//           'medium' — 'low' waited ~0.5-1 s longer before answering.
//           (?avatarEagerness=… overrides it per page load for trials.)
//  low    — noisy venues: like normal, plus OpenAI no longer interrupts or
//           replies on its own; a reply is requested only when the
//           transcript has real words, so noise never interrupts the avatar.

export const MIC_SENSITIVITY_DEFAULT = 'normal';

export const MIC_SENSITIVITY_PRESETS = {
    high: {
        noiseReduction: 'near_field',
        turnDetection: {
            type: 'server_vad',
            threshold: 0.9,
            prefix_padding_ms: 500,
            silence_duration_ms: 800,
            interrupt_response: true,
        },
        bargeInMs: 0,
        manualTurns: false,
    },
    normal: {
        noiseReduction: 'far_field',
        turnDetection: { type: 'semantic_vad', eagerness: 'medium', interrupt_response: true },
        bargeInMs: 300,
        manualTurns: false,
    },
    low: {
        noiseReduction: 'far_field',
        turnDetection: {
            type: 'semantic_vad',
            eagerness: 'low',
            interrupt_response: false,
            create_response: false,
        },
        bargeInMs: 600,
        manualTurns: true,
    },
};

export function getMicPreset(level) {
    return MIC_SENSITIVITY_PRESETS[level] || MIC_SENSITIVITY_PRESETS[MIC_SENSITIVITY_DEFAULT];
}

// Transcripts shorter than this (after trimming) are treated as noise.
export const MIN_TRANSCRIPT_CHARS = 2;
